import { Button } from '../../../../components/Button';
import { useAuth } from '../../../../hooks/useAuth';
import { useCart } from '../../../../hooks/useCart';
import { usePoints } from '../../../../hooks/usePoints';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import styles from './Award.module.css';

interface IAward {
  premiumId: string;
  premiumName: string;
  premiumImage: string;
  balancePlayer?: number;
  valueType: {
    label: string;
    value: string;
  };
  premiumType: {
    label: string;
    value: string;
  };
  premiumDescription: string;
  premiumPrice: number;
  inStock: number;
  active: number;
  amount: number;
  paymentValue?: number;
}

interface IAwardProps {
  award: IAward;
}

export function Award({ award }: IAwardProps) {
  const {
    addProductToCart,
    decrementProductToCart,
    removeProductToCart,
    isAwardMoney,
    isAwardVariable,
  } = useCart();
  const { player, client } = useAuth();
  const { remainingPoints, availableToRedeem } = usePoints();
  const balance =
    Number(player.totalPoints) -
    Number(player.redeemedPoints ? player.redeemedPoints : 0);

  const verifyDisableButtonAdd = (award: IAward) => {
    if (remainingPoints === 0) {
      return true;
    }

    if (award.premiumPrice > Number(remainingPoints)) {
      return true;
    }

    if (!award.inStock || !award.active || award.inStock <= 0) {
      return true;
    }

    if (award.amount > award.inStock) {
      return true;
    }

    return false;
  };

  return (
    <>
      <div className="row align-items-center">
        {/* imagem do item */}
        <div className="col-5 col-md-2">
          <div className="mb-3 mb-md-0">
            <div className={`${styles.imageRescue}`}>
              <img src={award.premiumImage} alt="" />
            </div>
          </div>
        </div>
        {/* fim imagem do item */}

        {/* nome do item */}
        <div className="col-7 col-md-4">
          <p className="m-0 fs-5 fw-semibold">{award.premiumName}</p>
          <p
            className="m-0 tiny-text text-nowrap d-inline-block text-truncate"
            style={{ width: '100%' }}
          >
            {award.premiumDescription}
          </p>
        </div>
        {/* fim nome do item */}

        {/* botão de add do item */}
        <div className="col-4 col-md-2">
          <div
            className="btn-group"
            role="group"
            aria-label="Basic outlined example"
          >
            <button
              type="button"
              className={`${styles.btnPrimary} btn btn-primary`}
              onClick={() => decrementProductToCart(award)}
            >
              <i className="material-icons-outlined tiny">remove</i>
            </button>
            <button
              type="button"
              className={`${styles.btnOutlinePrimary} btn color-text btn-outlined-primary`}
            >
              {award.amount}
            </button>
            <button
              type="button"
              className={`${styles.btnPrimary} btn btn-primary`}
              onClick={() => addProductToCart(award)}
              disabled={verifyDisableButtonAdd(award)}
            >
              <i className="material-icons-outlined tiny">add</i>
            </button>
          </div>
        </div>
        {/* fim botão de add do item */}

        {/* pontos do item */}
        <div className="col-5 col-md-3">
          {isAwardMoney && isAwardVariable ? (
            <>
              <p className="fs-5 fw-semibold m-0 text-center">
                {availableToRedeem
                  ? numberWithCommas(availableToRedeem)
                  : numberWithCommas(balance)}{' '}
                <span className="fw-normal">
                  {client?.coinName
                    ? client.coinName.replace(
                        /\((\w+)\)/,
                        (_, conteudo) => conteudo
                      )
                    : 'pontos'}
                </span>
              </p>
            </>
          ) : (
            <>
              <p className="fs-5 fw-semibold m-0 text-center">
                {numberWithCommas(award.amount * award.premiumPrice)}{' '}
                <span className="fw-normal">
                  {client?.coinName
                    ? client.coinName.replace(
                        /\((\w+)\)/,
                        (_, conteudo) => conteudo
                      )
                    : 'pontos'}
                </span>
              </p>
            </>
          )}
        </div>
        {/* fim pontos do item */}

        <div className="col-3 col-md-1">
          <div className="d-grid">
            <Button
              icon="delete"
              color="danger"
              onClick={() => removeProductToCart(award.premiumId)}
            />
          </div>
        </div>
      </div>
      <div className="my-3">
        <hr />
      </div>
    </>
  );
}
